import React, { useState, useEffect, useLayoutEffect } from "react";
import axios from "axios";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useNavigate, useLocation } from "react-router-dom";
import ProjectList from "./ProjectList";

ChartJS.register(ArcElement, Tooltip, Legend);

const Projects = () => {
  useLayoutEffect(() => {
    localStorage.removeItem("project_id");
    localStorage.setItem("project_id", -1);
    localStorage.removeItem("project_name");
    localStorage.removeItem("customer_id");

    console.log("Project ID Reset:", localStorage.getItem("project_id"));
  }, []);

  const [forecastData, setForecastData] = useState([]);
  const [projects, setProjects] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isData, setIsData] = useState(false);
  const [customerIds, setCustomerIds] = useState([]);
  const trialStatus = localStorage.getItem("04-09-2025");
  const navigate = useNavigate();
  const location = useLocation();

  const [totalDaysLeft, setTotalDaysLeft] = useState(1)
  const [totalProjects, setTotalProjects] = useState(1)

  useEffect(()=>{
    axios.post("https://api.confidanto.com/projects-data/subscription/project-summary",{
      email:localStorage.getItem("email")
    })
    .then(res=>{
      if(res.data){
        // setTotalDaysLeft(1)
        setTotalDaysLeft(res.data.remainingDays)
        setTotalProjects(res.data.totalProjects)
      }
    })
    .catch(err=>{
      console.error("Error: ", err)
    })
  })

  useEffect(() => {
    const storedProjects = JSON.parse(localStorage.getItem("projects")) || [];
    setProjects(storedProjects);
  }, []);

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post(
          "https://api.confidanto.com/forecast-user-dashboard",
          {
            category: "Travel and Tourism",
            region: "India",
            subcategories: ["Hotel booking platform"],
            startDate: "2024-01-01",
            endDate: "2024-01-05",
          }
        );
        if (isMounted) {
          setForecastData(response.data.forecastData);
          setIsData(true);
        }
      } catch (error) {
        if (isMounted) {
          console.error("Error fetching forecast data:", error);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const ids = searchParams.get("customer_ids");
    if (ids) {
      alert("Google Ads Account Connected Successfully...!");
      setCurrentStep(2);
      const idsArray = ids.split(",");
      setCustomerIds(idsArray);
    }
  }, [location.search]);

  const signUpDate = localStorage.getItem("start_date");
  const trialPeriodDays = 14;

  const trialEndDate = new Date(signUpDate);
  trialEndDate.setDate(trialEndDate.getDate() + trialPeriodDays);

  function calculateDaysLeftInTrial(trialEnd) {
    const currentDate = new Date();
    const timeDiff = trialEnd - currentDate;
    const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    return daysLeft;
  }

  const daysLeft = calculateDaysLeftInTrial(trialEndDate);
  const daysLeftText =
    daysLeft > 0 ? `${daysLeft} days left in your trial` : "Your trial has ended";

  localStorage.setItem("daysLeftStatus", daysLeftText);

  return (
    <div className="relative w-full min-h-screen bg-gray-50">
      {/* Main Content Area */}
      <div
        className={`container mx-auto px-4 py-6 transition duration-300 ${
          trialStatus === "Your trial has ended" ? "blur-sm pointer-events-none max-h-screen overflow-hidden" : ""
        }`}
      >
        <ProjectList totalDaysLeft={totalDaysLeft} />
      </div>
      {false && totalDaysLeft <= 0 && (
       <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
  <div className="bg-white rounded-xl shadow-lg p-6 md:p-10 max-w-lg w-full text-center space-y-4">
    <h1 className="text-xl md:text-2xl font-semibold text-gray-800">
              Your Free Trial has Ended
            </h1>
            <p className="text-base md:text-lg text-gray-600">
              Select your plan to continue accessing your workspace.
            </p>
            <button
              className="mt-4 px-6 py-2 rounded-md bg-blue-600 text-white text-sm md:text-base hover:bg-blue-700 transition duration-200"
              onClick={() => navigate("/billing-support")}
            >
              Select Your Plan
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
export default Projects;